import { FC } from 'react';

import { ContentFormatter, Copy, Heading, Modal, Stack } from '@belong/ui-components';

import CONTENT from '../content.json';

interface IAttachmentModalProps {
  openFileDialog: () => void;
  closeModal: () => void;
}

const ModalContent: FC = () => (
  <Stack>
    <ContentFormatter>
      {CONTENT.attachmentModal.content.map(value => (
        <Copy key={value}>{value}</Copy>
      ))}
    </ContentFormatter>
  </Stack>
);

export const AttachmentModal: FC<IAttachmentModalProps> = ({ openFileDialog, closeModal }) => (
  <Modal
    isOpen
    ariaLabelClose={CONTENT.ariaLabels.closeModal}
    onClose={closeModal}
    defaultContent={<ModalContent />}
    defaultHeading={<Heading variant="medium">{CONTENT.attachmentModal.heading}</Heading>}
    defaultObject={{
      primaryAction: openFileDialog,
      primaryBtnLabel: CONTENT.attachmentModal.buttonLabel
    }}
  />
);

AttachmentModal.displayName = 'AttachmentModal';
